/* global exports */
"use strict";

export function getGlobalCurrencyRaw() {
  return Skubacz.configuration.currency;
}
